import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import type { ReactNode } from 'react'
import { queryClient } from '@/shared/lib/tanstack'
import { CACHE_GC_TIME, QUERY_CACHE_KEY } from '@/shared/constants/cache'

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: QUERY_CACHE_KEY,
})

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister, maxAge: CACHE_GC_TIME }}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
